import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import _ from "lodash";
import moment from "moment";
import Button from "react-bootstrap-button-loader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { fetchEventDetails } from "DashboardUserAction";
import {
  publishProposal,
  manageProposalModal,
  fetchProposal,
  emptyProposalFormStatus,
} from "ProposalAction";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  COMMON_FAIL_MESSAGE,
  DOMAIN_NAME,
  DISPLAY_LOCAL_DATE_FORMAT,
} from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import LocaleStrings from "Languages";

class Publish extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      loading: false,
      checked: false,
      dateError: {},
      copied: false,
    };
  }

  componentDidMount() {
    this.props.fetchEventDetails(this.props.session);
  }

  closeModal() {
    this.props.manageProposalModal(false, "", "");
  }

  onSubmitForm = (values) => {
    // console.log("Form values", values);
    // debugger;
    if (
      values.application_startdate &&
      values.application_enddate &&
      values.review_startdate &&
      values.review_enddate
    ) {
      let application_startdate =
        typeof values.application_startdate === "string"
          ? moment(
              values.application_startdate,
              DISPLAY_LOCAL_DATE_FORMAT
            ).format("YYYY-MM-DD")
          : moment(values.application_startdate).format("YYYY-MM-DD");

      var application_enddate =
        typeof values.application_enddate === "string"
          ? moment(
              values.application_enddate,
              DISPLAY_LOCAL_DATE_FORMAT
            ).format("YYYY-MM-DD")
          : moment(values.application_enddate).format("YYYY-MM-DD");

      var review_startdate =
        typeof values.review_startdate === "string"
          ? moment(values.review_startdate, DISPLAY_LOCAL_DATE_FORMAT).format(
              "YYYY-MM-DD"
            )
          : moment(values.review_startdate).format("YYYY-MM-DD");
      var review_enddate =
        typeof values.review_enddate === "string"
          ? moment(values.review_enddate, DISPLAY_LOCAL_DATE_FORMAT).format(
              "YYYY-MM-DD"
            )
          : moment(values.review_enddate).format("YYYY-MM-DD");

      if (
        application_startdate &&
        application_enddate &&
        application_enddate >= application_startdate
      ) {
        if (
          review_startdate &&
          review_enddate &&
          review_enddate >= review_startdate
        ) {
          let proposalid = "";
          let data = {};
          if (values.proposalid) {
            proposalid = values.proposalid;
            data.proposalid = values.proposalid;
          } else {
            let { checkProposalForm } = this.props;
            let proposalForm =
              checkProposalForm &&
              checkProposalForm.data &&
              checkProposalForm.data.length > 0
                ? checkProposalForm.data[0]
                : {};
            values.proposalid = proposalForm.proposalid;
            data.proposalid = proposalForm.proposalid;
          }
          data.ispublished = 1;
          data.isresubmit = values.isresubmit ? 1 : 0;
          data.application_startdate = application_startdate;
          data.application_enddate = application_enddate;
          data.review_startdate = review_startdate;
          data.review_enddate = review_enddate;

          // console.log("final data :- ", data);

          this.setState({ loading: true });
          this.props.publishProposal(this.props.session, data, (response) => {
            if (response.success === 0) {
              this.setState({ loading: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              this.props.fetchProposal(this.props.session, (callback) => {});
              if (this.props.comesfrom == "Add") {
                this.props.emptyProposalFormStatus();
              }

              this.setState({ loading: false });
              this.props.showSuccess(
                LocaleStrings.proposal_form_published_successfully
              );

              if (proposalid) {
                this.closeModal();
              } else {
                this.props.history.push("/dashboard/tickets/proposaldashboard");
              }
            }
          });
        } else {
          var errorMessage = "";
          var enderrorMessage = "";
          if (!review_startdate) {
            errorMessage =
              LocaleStrings.tickets_ticket_form_validation_required;
          }
          if (!review_enddate) {
            enderrorMessage =
              LocaleStrings.tickets_ticket_form_validation_required;
          } else if (review_enddate < review_startdate) {
            enderrorMessage =
              LocaleStrings.proposal_publish_form_validation_review_end_date_should_greater_equal_than_review_start_date;
          }
          let dateError = {
            reviewstartdateError: errorMessage,
            reviewenddateError: enderrorMessage,
          };
          this.setState({ dateError: dateError });

          this.props.dispatch(
            setSubmitFailed("PublishForm", "review_startdate")
          );
          this.props.dispatch(setSubmitFailed("PublishForm", "review_enddate"));
          this.props.dispatch(
            stopSubmit("PublishForm", new Error(errorMessage))
          );
          this.props.dispatch(
            stopSubmit("PublishForm", new Error(enderrorMessage))
          );

          setTimeout(() => {
            this.setState({ dateError: {} });
          }, 2000);
        }
      } else {
        var errorMessage = "";
        var enderrorMessage = "";
        if (!application_startdate) {
          errorMessage = LocaleStrings.tickets_ticket_form_validation_required;
        }
        if (!application_enddate) {
          enderrorMessage =
            LocaleStrings.tickets_ticket_form_validation_required;
        } else if (application_enddate < application_startdate) {
          enderrorMessage =
            LocaleStrings.proposal_publish_form_validation_application_end_date_should_greater_equal_than_application_start_date;
        }

        let dateError = {
          appstartdateError: errorMessage,
          appenddateError: enderrorMessage,
        };
        this.setState({ dateError: dateError });

        this.props.dispatch(
          setSubmitFailed("PublishForm", "application_startdate")
        );
        this.props.dispatch(
          setSubmitFailed("PublishForm", "application_enddate")
        );
        this.props.dispatch(stopSubmit("PublishForm", new Error(errorMessage)));
        this.props.dispatch(
          stopSubmit("PublishForm", new Error(enderrorMessage))
        );

        setTimeout(() => {
          this.setState({ dateError: {} });
        }, 2000);
      }
    }
  };

  renderFieldRadio(field) {
    return (
      <div>
        <label
          className="custom-container-radio liveqa-label"
          style={{ marginBottom: 5 }}
        >
          {field.label}
          <input {...field.input} type={field.type} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }

  renderFieldCheckbox(field) {
    return (
      <div>
        <label
          className="custom-container-checkbox"
          style={{ marginBottom: 5 }}
        >
          {field.label}
          <input type={field.type} {...field.input} />
          <span className="checkmark" />
        </label>
      </div>
    );
  }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      eventDetails,
      checkProposalForm,
      initialValues,
      updateProposal,
    } = this.props;
    const minDate = new Date();

    // console.log('checkProposalForm',this.props.comesfrom)
    //console.log('updateProposal',updateProposal);

    let checked = false;

    let step1 = "fa fa-chevron-circle-down";
    let step1active = "steps-icon-arrow";
    if (this.state.step1) {
      step1 = "fa fa-chevron-circle-up";
      step1active = "steps-icon-arrow activeup";
    }

    let step2 = "fa fa-chevron-circle-down";
    let step2active = "steps-icon-arrow";
    if (this.state.step2) {
      step2 = "fa fa-chevron-circle-up";
      step2active = "steps-icon-arrow activeup";
    }
    let proposalForm = "";
    let proposal_name = "";
    let form_name = "";
    let formnumber = "";
    let proposalid = "";
    let btnUpdate = false;
    if (
      checkProposalForm &&
      checkProposalForm.data &&
      checkProposalForm.data.length > 0
    ) {
      proposalForm =
        checkProposalForm &&
        checkProposalForm.data &&
        checkProposalForm.data.length > 0
          ? checkProposalForm.data[0]
          : {};
      proposal_name =
        proposalForm && proposalForm.proposal_name
          ? proposalForm.proposal_name
          : "";
      //form_name = proposalForm && proposalForm.event_forms_by_formid && proposalForm.event_forms_by_formid.form_name ? proposalForm.event_forms_by_formid.form_name : '';
      //formnumber = proposalForm && proposalForm.event_forms_by_formid && proposalForm.event_forms_by_formid.formnumber ? proposalForm.event_forms_by_formid.formnumber : '';
      proposalid =
        proposalForm && proposalForm.proposalid ? proposalForm.proposalid : "";
    } else if (updateProposal) {
      proposal_name =
        updateProposal && updateProposal.proposal_name
          ? updateProposal.proposal_name
          : "";
      //form_name = updateProposal && updateProposal.event_forms_by_formid && updateProposal.event_forms_by_formid.formname ? updateProposal.event_forms_by_formid.formname : '';
      //formnumber = updateProposal && updateProposal.event_forms_by_formid && updateProposal.event_forms_by_formid.formnumber ? updateProposal.event_forms_by_formid.formnumber : '';
      proposalid =
        updateProposal && updateProposal.proposalid
          ? updateProposal.proposalid
          : "";
      btnUpdate = true;
    }

    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    var ticketUrl = `https://${seocode}.${DOMAIN_NAME}/t/proposals/${proposalid}`;
    let bottomClass = "dashboard-bottombar-proposal";
    if (this.props.comesfrom == "editAbstract") {
      bottomClass = "";
    }
    return (
      <div style={{ width: "70%" }}>
        <div className="row" style={{ marginBottom: 40 }}>
          <div
            className="col-md-12"
            style={{ marginBottom: "10px", paddingLeft: "20px" }}
          >
            <div className="publish-heading">
              {" "}
              {LocaleStrings.proposal_wizard_review_publish_heading}
            </div>
            <div className="publish-sub-heading">
              {" "}
              {LocaleStrings.proposal_wizard_review_publish_subheading}
            </div>
          </div>
          <div className="col-md-12">
            <div className="ticket-dashboard-ticket-created-page-main-div-new">
              <div className="heading-para-proposal">{proposal_name}</div>

              <div className="row">
                <div className="col-md-10">
                  <div className="copy-ticket-page">
                    <div className="ticket-url">{ticketUrl}</div>
                    <CopyToClipboard text={ticketUrl} onCopy={this.copyUrl}>
                      <div className="url-copy">
                        <i className="fa fa-files-o" aria-hidden="true"></i>
                        &nbsp;{LocaleStrings.button_copy}
                      </div>
                    </CopyToClipboard>
                  </div>
                  {this.state.copied ? (
                    <span style={{ color: "black", float: "right" }}>
                      {LocaleStrings.copied}.
                    </span>
                  ) : null}
                </div>
                <div className="col-md-2">
                  <a
                    href={ticketUrl}
                    target="blank"
                    className="btn btn-lg btn-primary"
                    style={{ padding: "8px 20px" }}
                  >
                    <span aria-hidden="true">{LocaleStrings.button_visit}</span>
                  </a>
                </div>
              </div>
              {/* <h4 className="heading-para">{form_name}</h4> */}
            </div>
          </div>
        </div>

        <div className="row">
          <div
            className="col-md-12"
            style={{ marginBottom: "10px", paddingLeft: "20px" }}
          >
            <div className="publish-heading">
              {LocaleStrings.proposal_wizard_before_publish_heading}
            </div>
            <div className="publish-sub-heading">
              {LocaleStrings.proposal_wizard_before_publish}
            </div>
          </div>
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <div className="col-md-12">
              <div className="ticket-dashboard-steps-main-div">
                <div>
                  <div className="row">
                    <div className="col-md-12 mb-5">
                      <div className="form-group">
                        <label className="control-label-top col-sm-12  m-0 mb-5">
                          {
                            LocaleStrings.proposal_wizard_review_publish_application_duration
                          }
                          <span className="label-mandatory">*</span>
                        </label>

                        <div className="col-md-12 col-sm-12 col-sm-offset-0">
                          <div className="row">
                            <div
                              className="col-md-5"
                              style={{ paddingRight: 0 }}
                            >
                              <Field
                                name="application_startdate"
                                type="text"
                                component={this.renderDatePicker}
                                // mandatory="true"
                                minDate={minDate}
                              />
                              {this.state.dateError &&
                              this.state.dateError.appstartdateError &&
                              this.state.dateError.appstartdateError !== "" ? (
                                <span style={{ color: "#d43f3a" }}>
                                  {this.state.dateError.appstartdateError}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div
                              className="col-md-5"
                              style={{ paddingRight: 0 }}
                            >
                              <Field
                                name="application_enddate"
                                type="text"
                                component={this.renderDatePicker}
                                // mandatory="true"
                                minDate={minDate}
                              />
                              {this.state.dateError &&
                              this.state.dateError.appenddateError &&
                              this.state.dateError.appenddateError !== "" ? (
                                <span style={{ color: "#d43f3a" }}>
                                  {this.state.dateError.appenddateError}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 mb-5">
                      <div className="form-group">
                        <label className="control-label-top col-sm-12  m-0 mb-5">
                          {
                            LocaleStrings.proposal_wizard_review_publish_review_duration
                          }
                          <span className="label-mandatory">*</span>
                        </label>

                        <div className="col-md-12 col-sm-12 col-sm-offset-0">
                          <div className="row">
                            <div
                              className="col-md-5"
                              style={{ paddingRight: 0 }}
                            >
                              <Field
                                name="review_startdate"
                                type="text"
                                component={this.renderDatePicker}
                                // mandatory="true"
                                minDate={minDate}
                              />
                              {this.state.dateError &&
                              this.state.dateError.reviewstartdateError &&
                              this.state.dateError.reviewstartdateError !==
                                "" ? (
                                <span style={{ color: "#d43f3a" }}>
                                  {this.state.dateError.reviewstartdateError}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div
                              className="col-md-5"
                              style={{ paddingRight: 0 }}
                            >
                              <Field
                                name="review_enddate"
                                type="text"
                                component={this.renderDatePicker}
                                // mandatory="true"
                                minDate={minDate}
                              />
                              {this.state.dateError &&
                              this.state.dateError.reviewenddateError &&
                              this.state.dateError.reviewenddateError !== "" ? (
                                <span style={{ color: "#d43f3a" }}>
                                  {this.state.dateError.reviewenddateError}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 mb-5">
                      <div className="form-group">
                        {/* <label className="control-label-top col-sm-12  m-0 mb-5">
                                {LocaleStrings.proposal_setting}<span className="label-mandatory">*</span>
                            </label> */}

                        <div className="col-md-12 col-sm-12 col-sm-offset-0">
                          <div className="row">
                            <div
                              className="col-md-12"
                              style={{ paddingRight: 0, marginTop: "10px" }}
                            >
                              <div style={{ display: "flex" }}>
                                <Field
                                  name="isresubmit"
                                  label={
                                    LocaleStrings.proposal_allow_resubmission
                                  }
                                  component={this.renderFieldCheckbox}
                                  type="checkbox"
                                />
                                <i
                                  className="fa fa-exclamation-circle resubmission-tooltip"
                                  style={{
                                    marginLeft: "6px",
                                    marginTop: 2,
                                    cursor: "pointer",
                                  }}
                                  aria-hidden="true"
                                ></i>
                                <div className="resubmission-tooltiptext">
                                  User can resubmit the application multiple
                                  times until its reviewed
                                </div>
                              </div>

                              {/* <div>
                                            {LocaleStrings.proposal_setting_note_text2}
                                          </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-12">
                      <Button
                        style={{ marginTop: 10, marginRight: 15 }}
                        className="button-theme button-theme-blue pull-right"
                        bsStyle="primary"
                        loading={this.state.loading}
                        disabled={
                          btnUpdate ? false : pristine || invalid || submitting
                        }
                        type="submit"
                      >
                        {LocaleStrings.proposal_wizard_review_publish_button}
                      </Button>
                    </div> */}
                    {/* <div className="dashboard-bottombar-proposal">
            <div className="col-md-7"></div> 
            <div className="col-md-5 button-save-col">
            <Button
            className="btn btn-custom-blue mt-10"
            bsStyle=""
            loading={this.state.loading}
            disabled={initialValues ? false : pristine || invalid || submitting}
            type="submit"
          >
            {LocaleStrings.proposal_wizard_review_publish_button}
          </Button>
              </div> 
         </div> */}
                  </div>
                  {/* </form> */}
                </div>
              </div>
            </div>
            <div className={bottomClass} style={{ marginLeft: "-17px" }}>
              <div className="col-md-5- button-save-col">
                <Button
                  className="btn btn-custom-blue mt-10"
                  bsStyle=""
                  loading={this.state.loading}
                  disabled={
                    initialValues ? false : pristine || invalid || submitting
                  }
                  type="submit"
                >
                  {LocaleStrings.proposal_wizard_review_publish_button}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  var initVals = {};

  if (state.updateProposal) {
    initVals = state.updateProposal ? state.updateProposal : {};
  }

  return {
    session: state.session,
    checkProposalForm: state.checkProposalForm,
    eventDetails: state.userEventDetails,
    initialValues: initVals,
    updateProposal: state.updateProposal,
  };
}

function validate(values) {
  //console.log("validate", values);
  var errors = {};
  var application_startdate = values["application_startdate"];
  var application_enddate = values["application_enddate"];
  var review_startdate = values["review_startdate"];
  var review_enddate = values["review_enddate"];

  if (application_startdate == null) {
    errors["application_startdate"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (application_enddate == null) {
    errors["application_enddate"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (review_startdate == null) {
    errors["review_startdate"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (review_enddate == null) {
    errors["review_enddate"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (!values.settings && values.settings == null) {
    errors["settings"] = LocaleStrings.tickets_ticket_form_validation_required;
  }
  return errors;
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchEventDetails,
  publishProposal,
  manageProposalModal,
  fetchProposal,
  emptyProposalFormStatus,
})(
  reduxForm({
    validate,
    form: "PublishForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Publish)
);
